const Map = (state = null, action) => {
    switch (action.type) {
        case  'SET_MAP':
            return action.payload;
    }
    return state
}

export default Map;




// WEBPACK FOOTER //
// ./src/reducers/Map.js